import React, { useState, useEffect } from 'react';
/* import { requestPublics } from '../services/requests';
import DOMPurify from 'dompurify'; */
import { RiCloseLine } from 'react-icons/ri';
import { useLocation } from 'react-router-dom';
import { FaRegFileImage } from 'react-icons/fa';
/* import linkedin from '../images/Blog images/linkedin.png';
import facebook from '../images/Blog images/facebook.png';
import whatsapp from '../images/Blog images/whatsapp.png';
import instagram from '../images/Blog images/instagram_icon.png';
import linkedin_invert from '../images/Blog images/linkedin_invert.png';
import facebook_invert from '../images/Blog images/facebook_invert.png';
import whatsapp_invert from '../images/Blog images/whatsapp_invert.png';
import instagram_invert from '../images/Blog images/instagram_icon_invert.png'; */

const BlogCardExpand = ({ sendDataToParent, currentEvent }) => {
	const [urlEvent, setUrlEvent] = useState([]);
	const location = useLocation();
	function traduzirData(dataISO) {
		const meses = [
			'Janeiro',
			'Fevereiro',
			'Março',
			'Abril',
			'Maio',
			'Junho',
			'Julho',
			'Agosto',
			'Setembro',
			'Outubro',
			'Novembro',
			'Dezembro',
		];

		const [ano, mes, dia] = dataISO.split('-');
		return `${parseInt(dia)} de ${meses[parseInt(mes) - 1]} de ${ano}`;
	}

	const [hasError, setHasError] = useState(false);

	const sendData = (event) => {
		const backgroundColor = window.getComputedStyle(
			event.target
		).backgroundColor;

		if (
			backgroundColor === 'rgba(0, 0, 0, 0.7)' ||
			event.target.id === 'close'
		) {
			const data = false;
			sendDataToParent(data);
		}
	};

	const gerarCorAleatoria = () => {
		const cores = [
			'#69314C',
			'#6E3630',
			'#28456C',
			'#5A5A5A',
			'#2B593F',
			'#28456C',
			'#492F64',
		];
		cores.sort(() => Math.random() - 0.5);
		return cores;
	};

	useEffect(() => {
		if (currentEvent) {
			window.history.pushState(null, '', `/blog/${currentEvent.id}`);
		}
		const handleKeyPress = (event) => {
			if (event.key === 'Escape') {
				sendDataToParent(false);
				const currentPath = window.location.pathname;
				const newPath = currentPath.substring(
					0,
					currentPath.lastIndexOf('/')
				);
				window.history.pushState(null, '', newPath);
			}
		};

		window.addEventListener('keydown', handleKeyPress);

		// Cleanup para evitar múltiplos listeners
		return () => {
			window.removeEventListener('keydown', handleKeyPress);
		};
	}, []);

	const imageUrl = currentEvent?.imagem
		? `${currentEvent.imagem.replace(
				/-dev/g,
				''
		  )}?t=${new Date().getTime()}`
		: null;

	const handleError = () => {
		if (imageUrl === null || imageUrl === undefined) {
			setHasError(true);
		} else {
			setHasError(false);
		}
	};

	return (
		<div
			onClick={(e) => {
				window.history.pushState(
					null,
					'',
					window.location.pathname.substring(
						0,
						window.location.pathname.lastIndexOf('/')
					)
				);
				sendData(e);
			}}
			className='font-inter fixed inset-0 bg-black z-20 bg-opacity-70 flex items-center justify-center '>
			<div
				className='absolute  inset-[-50px] sm:inset-0 mx-auto sm:mt-0 mt-[50px] scale-[75%] sm:scale-[75%] z-30 sm:w-[70%]  font-bold rounded-2xl bg-[#FFFFFF] 
 shadow-lg transition-all easy-in-out duration-200'>
				<div className='flex justify-end   shadow-lg h-[30px]'>
					<div
						onClick={() => {
							window.history.pushState(
								null,
								'',
								window.location.pathname.substring(
									0,
									window.location.pathname.lastIndexOf('/')
								)
							);
							sendDataToParent(false);
						}}>
						<button
							id='close'
							className='flex justify-center right-0 rounded-tr-xl hover:text-white text-[#BDBDBD] w-[70px] h-[30px] bg-white transition-all hover:bg-[#B74644] '>
							<RiCloseLine
								id='close'
								size={30}
							/>
						</button>
					</div>
				</div>
				<div
					className='overflow-y-scroll font-bold h-[100%] rounded-b-2xl bg-[#FFFFFF] w-[100%] 
             [&::-webkit-scrollbar]:w-5
             [&::-webkit-scrollbar-track]:rounded-br-lg
             [&::-webkit-scrollbar-thumb]:rounded-br-lg
             [&::-webkit-scrollbar-track]:bg-gray-50
             [&::-webkit-scrollbar-thumb]:bg-gray-200
             dark:[&::-webkit-scrollbar-track]:bg-neutral-200
             dark:[&::-webkit-scrollbar-thumb]:bg-neutral-400'>
					<div className='w-full h-[293px]  bg-[#E3E3E3]'>
						{/* <img
							className='w-full h-full object-cover'
							alt='imagem da noticia'
							src={
								currentEvent
									? currentEvent.imagem
									: urlEvent.length > 0
									? urlEvent[0][0].imagem
									: ''
							}></img> */}

						{imageUrl ? (
							<img
								className='w-full h-full object-cover object-center'
								alt='foto'
								src={imageUrl}
								onError={handleError}
							/>
						) : (
							<div className='h-[100%] flex justify-center text-gray-300 mx-auto content-center items-center'>
								<FaRegFileImage className='w-[80px] h-[80px]' />
							</div>
						)}
					</div>
					<div className='relative font-light grid grid-rows-[auto,auto,1fr] gap-[18px] py-[15px] px-[10%] xs:px-[126px]'>
						<div className='text-[#555555] text-start font-medium text-[35px]'>
							{currentEvent
								? currentEvent.titulo
								: urlEvent.length > 0
								? urlEvent[0][0].titulo
								: ''}
						</div>
						<div className='flex flex-wrap gap-2  overflow-hidden'>
							{(currentEvent
								? currentEvent.tags
								: urlEvent.length > 0
								? urlEvent[0][0].tags
								: 'nenhuma tag'
							)
								.split(',')
								.map((topic, i) => (
									<div
										key={i}
										className='px-[8px] py-[3px] rounded-[4px] text-[14px] font-normal text-[#ececec] flex-shrink-0'
										style={{
											backgroundColor:
												gerarCorAleatoria()[i],
										}}>
										{topic}
									</div>
								))}
						</div>
						{/* {console.log('PROP', currentEvent)} ba*/}
						<div className='self-end'>
							<p className='text-[#757575] font-normal text-[18px] text-start'>
								{currentEvent
									? traduzirData(currentEvent.data_publicacao)
									: urlEvent.length > 0
									? traduzirData(
											urlEvent[0][0].data_publicacao
									  )
									: ''}
							</p>
						</div>
						<div className='h-[2px] bg-[#E3E3E3]'></div>
						<p className='text-gray-800 text-start text-xl'>
							<div
								dangerouslySetInnerHTML={{
									__html: currentEvent
										? currentEvent.conteudo
										: urlEvent.length > 0
										? urlEvent[0][0].conteudo
										: '',
								}}
							/>
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BlogCardExpand;
